export type CategoryIDList = string[];

export const FASHION_CHILDREN_2_PLUS_CATEGORY_IDS: CategoryIDList = [
  "600001343",
  "600001345",
  "90000410022",
];

export const FASHION_BRAS_CATEGORY_IDS: CategoryIDList = ["8000016892"];

export const FASHION_CHILDRENSWEAR_CATEGORY_IDS: CategoryIDList = [
  "6000030",
  "6000034",
  "6000150170",
];

export const FASHION_DEFAULT_CATEGORY_IDS: CategoryIDList = [
  "50000298",
  "50000300",
];

export const ELECTRICALS_DEFAULT_CATEGORY_IDS: CategoryIDList = [
  "6000052", // Fridges & freezers
  "6000047", // Dishwashers
  "600002446", // Washing machines & tumble dryers
  "8000013309", // Cookers
  "80000462", // Built-in ovens
  "80000463", // Hobs
  "600002591", // Microwaves
  "80000973", // Cooker hoods
  "800009348", // Warming drawers
  "80000398", // Laptops
  "9600620006", // Desktop PCs
  "800004408", // Mobile phones
  "8000021438", // Tablets
  "7000430163", // Smart watches
  "6000084", // Televisions
];

export const ELECTRICALS_ADDITIONAL_CATEGORY_IDS: CategoryIDList = [
  "80000513", // Fridge freezers
  "80000512", // Freezers
  "80000514", // Fridges
  "600001119", // Tumble dryers
  "80000529", // Coffee machines
  "600001115", // Washer dryers
  "8000020112", // Washing machines
  "9780421086", // Soundbars
  "800005013", // TVs
  "600001695", // Toasters
  "600001693", // Kettles
  "80000660", // Headphones
  "8000021438", // Tablets
  "800004002", // Cameras
  "6000600036", // Playstation
  "700008000", // Nintendo
  "6000580247", // Xbox
  "80000543", // Food mixers
  "800005069", // Vacuum cleaners
  "80000545", // Food processors
  "80000535", // Air fryers & grills
  "80000688", // Hair dryer
  "800001975", // Hair straighteners
  "800001974", // Hair stylers
  "8000019939", // Hand blender
  "80000525", // Food blenders
  "20000150109", // Pizza ovens
  "80000518", // Steam irons & generators
  "80000488", // Fans
  "9500580010", // Heaters
  "800001359", // Air purifiers & heaters
  "9835350012", // Air conditioners & heaters
  "9835350025", // Electric blankets & throws
  "80000537", // Ice cream makers
  "300000005268", // Men's grooming devices
  "8000028130", // Camera lenses
  "80000431", // Speakers
  "700001542", // Hi-fi & CD players
  "800001842", // Radios
  "800006057", // Camera tripods, adapters & remotes
  "700009427", // Turntables
  "9780421096", // Mini ovens, slow cookers & steamers
  "7000010829", // eReaders, cases & accessories
  "9600230010", // Smart home monitoring
  "600002645", // TV recorders & streaming devices
  "300000005266", // Routers & broadband
  "300000005264", // Data storage
  "60000300031", // Gaming accessories (non PS, Xbox, Nintendo)
  "80000443", // Printers
  "9500270143", // Virtual reality
  "700005666", // Keyboards & mice
  "700009271", // Webcams
  "600002760", // Monitors
  "6000580061", // Scanners
  "8000013919", // Telescopes
  "9780040011", // Soup maker
  "700009111", // Shredders
  "8000012384", // Milk frothers
  "800004000", // Camcorders
  "80000526", // Bread makers
  "800001358", // Dehumidifiers
  "9200010055", // PC software
  "800001360", // Humidifiers
  "700008777", // Home telephones
  "800004741", // Blu-ray & DVD players
  "9780421097", // Fondue sets
  "7000350277", // Hair curlers
  "80000528", // Coffee grinders
  "80000702", // Women's hair removal
  "80000538", // Juicers & pressers
  "80000533", // Electric knives & sharpeners
  "800003939", // Camera flashes, grips & filters
  "80000803", // Trouser and shirt press
  "800001979", // Electric toothbrushes, flossers & accessories
  "9500250213", // Gadgets
  "9600230008", // Smart lighting
  "9600230006", // Smart heating
  "300000006270", // Floorcare (carpet cleaners)
  "100000760008", // Sat navs
  "60000230042", // Smart plugs
  "40000480070", // Facial treatment tools
  "80000515", // Wine cabinets
  "90000540025", // Projectors
];

export const BEAUTY_DEFAULT_CATEGORY_IDS: CategoryIDList = ["50000296"];

export const MADE_TO_MEASURE_CATEGORY_IDS: CategoryIDList = ["5000070286"];
